/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

'use client';

import { createContext } from 'react';
import { KahuContextType, KahuFloatingDock } from 'types/kahu';
import { NarrativeContextValue } from 'types/narrative-graph';

const AuthContext = createContext<any>(null);
const ToggleContext = createContext<any>(null);
const TourContext = createContext<any>(null);
const PromptsContext = createContext<any>(null);
const TracesContext = createContext<any>(null);
const TracesIDContext = createContext<any>(null);
const AppDetailsContext = createContext<any>(null);
const KPIContext = createContext<any>(null);
const ProvidersContext = createContext<any>(null);
const ServicesContext = createContext<any>(null);
const ComponentsContext = createContext<any>(null);
const MeasuresCacheContext = createContext<any>(null);
const ApplicationsContext = createContext<any>(null);
const SplitPromptSequenceContext = createContext<any>(null);
const EvaluateContext = createContext<any>(null);
const DateRangeContext = createContext<any>(null);
const KahuContext = createContext<KahuContextType | null>(null);
const UsageContext = createContext<UsageContextType | null>(null);
const NarrativeContext = createContext<NarrativeContextValue | null>(null);

const KahuFloatingDockContext = createContext<KahuFloatingDock>({
  dockEl: null,
  scrollRoot: null,
});

export {
  AuthContext,
  ToggleContext,
  TourContext,
  PromptsContext,
  TracesContext,
  TracesIDContext,
  AppDetailsContext,
  KPIContext,
  ProvidersContext,
  ServicesContext,
  ComponentsContext,
  MeasuresCacheContext,
  ApplicationsContext,
  SplitPromptSequenceContext,
  KahuFloatingDockContext,
  EvaluateContext,
  DateRangeContext,
  KahuContext,
  UsageContext,
  NarrativeContext,
};
